<template>
    <section id="films" class="section_films">
        <h2 class="section--title">Films</h2>
        <div class="grid-container">
            <div class="grid-x align-center">
                <p class="film_article--list--notice cell small-12 medium-10">各作品解説：吉田伊知郎</p>
            </div>
            <ul class="film_article--list grid-x grid-padding-x align-center">
                <li class="cell small-12 large-5" v-for="film in films" :key="film.id">
                    <films-item :film="film"></films-item>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
import FilmsItem from '@/components/FilmsItem'
export default {
    name: 'films',
    components: {FilmsItem},
    data () {
        return {
            films: [
                {
                    id: '13',
                    title: 'ハッピーアワー',
                    information: '製作：神戸ワークショップシネマプロジェクトプロデューサー：高田聡、岡本英之、野原位 / 監督：濱口竜介 /  脚本：はたのこうぼう（濱口竜介、野原位、高橋知由） / 撮影：北川喜雄 / 録音：松野泉 / 照明：秋山恵二郎 / 助監督：斗内秀和、高野徹音楽：阿部海太郎<br>出演：田中幸恵、菊池葉月、三原麻衣子、川村りら　ほか<br>2015年 / 317分 / HD / カラー\n',
                    synopsis: '３０歳を過ぎて友人になった４人の女性たち。彼女たちを結びつけた１人が抱える秘密が明かされた時、３人の日常も揺らぎだす。即興演技ワークショップの参加者が出演し、主人公たちの家族、恋人、出会う人々にまで豊かな枝葉を伸ばす珠玉の５時間。電車、駅のホーム、バス、テーブルを囲んだ対話など、従来の濱口作品にあった場面がより洗練され、山と海が隣接する神戸の地形を活かした撮影も魅力を放つ。１０年代を代表する傑作。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_01_img.jpg'
                },
                {
                    id: '12',
                    title: '親密さ',
                    information: '製作：ENBUゼミナール / 監督・脚本：濱口竜介<br>撮影：北川喜雄 / 編集：鈴木宏 / 整音：黄永昌 / 助監督：佐々木亮介 / 制作：工藤渉 / 劇中歌：岡本英之<br>出演：平野鈴、佐藤亮、伊藤綾子、田山幹雄　ほか<br>2012年 / 255分 / HD / カラー',
                    synopsis: '演劇の上演からなる後半と、その過程を描いた前半の２部構成による巨編。海の向こうで戦争が始まった世界を舞台に、脚本家と演出家のカップルが舞台を作り上げる。恐怖・戦争をめぐる討論やインタビューなど実際の舞台稽古で行われた部分に、演じた部分を重ねることで戦時下の演劇という虚構を成立させる。夜明けまでの数十分を話しながら歩くロングテイクが忘れ難い。濱口が講師を務めたENBUゼミナール映像俳優コース卒業制作。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_02_img.jpg'
                },
                {
                    id: '11',
                    title: 'THE DEPTHS',
                    information: '製作：東京藝術大学大学院映像研究科・韓国国立フィルムアカデミー / プロデューサー：原尭志、シム・ユンボ / 監督：濱口竜介 / 脚本：濱口竜介、大浦光太 / 撮影監督：ヤン・グニョン / 照明：後閑健太 / 整音：金地宏晃 / 美術：田中浩二 / 編集：山崎梓 / 助監督：菊地健雄<br>出演：キム・ミンジュン、石田法嗣、パク・ソヒ、米村亮太朗、村上淳ほか<br>2010年 / 121分 / HD（Blu-ray上映） / カラー',
                    synopsis: '東京藝術大学と韓国国立映画アカデミーの合作。友人の結婚式へ来日したカメラマン、ペファンは男娼リュウの魅力に惹かれて韓国へ連れ帰ろうとする。濱口映画の根幹を担う対話が、韓国語と日本語で交わされることによる壁をはじめ劇中には境界線が張り巡らされているが、題名にもある深度を増すことで境界は消えていく。石田法嗣との最初の出会いとなり、彼に向けられる眼差しは、今後の作品で重要な位置を占めることを予感させる。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_03_img.jpg'
                },
                {
                    id: '10',
                    title: 'PASSION',
                    information: '製作：東京藝術大学大学院映像研究科 / プロデューサー：藤井智 / 監督・脚本：濱口竜介 / 撮影：湯澤祐一 / 照明：佐々木靖之 / 録音：草刈悠子美術：安宅紀史、岩本浩典 / 編集：山本良子 / 助監督：野原位<br>出演：河井青葉、岡本竜汰、占部房子、岡部尚、渋川清彦　ほか<br>2008年 / 115分 / HD（Blu-ray上映） / カラー',
                    synopsis: '濱口の名を知らしめた東京藝術大学映像研究科修了作品。結婚を発表したカップルと友人たちの関係に変化が訪れる。あたかもトレンディドラマの様な設定から暴力をめぐる討論、本音ゲームへと対話劇が発展する一方で『ハッピーアワー』でも際立った都市を切り取る視点が突出。横浜を映画的な都市へと変貌させ、終盤の１０分に及ぶ長回しで風景と言語を一体化させる。脚本家・荒井晴彦は「俺はこんな映画を書きたかった」と絶賛した。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_04_img.jpg'
                },
                {
                    id: '9',
                    title: '不気味なものの肌に触れる',
                    information: '製作：LOAD SHOW、 fictive / プロデューサー：北原豪、 岡本英之、 濱口竜介 / 監督：濱口竜介 / 脚本：高橋知由 / 撮影：佐々木靖之 / 音楽：長嶌寛幸 / 録音：黄永昌 / 助監督：野原位 / 制作：城内政芳    振付：砂連尾理<br>出演：染谷将太、石田法嗣、渋川清彦、 瀬戸夏実、水越朝弓、河井青葉、村上淳　ほか<br>2013年 / 54分 / HD / カラー / ©︎LOAD SHOW,fictive',
                    synopsis: '『ハッピーアワー』始動前に関西の特集上映のために制作された中篇。父を亡くして義兄に引き取られた千尋は、ダンスパートナーの直也との時間に没頭する。表題の触覚性を染谷将太と石田法嗣の身体性とインタビュー形式の対話によって表出させた上で師・黒沢清への接近と言うべき不穏な空間を全篇に作り上げて見せる。来るべき長編『FLOODS』のパイロット版であり、今後の濱口映画の新たな展開を予感させる刺激に満ちている。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_05_img.jpg'
                },
                {
                    id: '8',
                    title: '永遠に君を愛す',
                    information: '製作：竹澤平八郎 / 監督：濱口竜介 / 脚本：渡辺裕子 / 撮影：青木穣 / 照明：後閑健太 / 録音：金地宏晃<br>整音：上條慎太郎 / 美術：原尚子 / 編集：山崎梓 / 助監督：佐々木亮介 / 音楽：岡本英之<br>出演：河井青葉、杉山彦々、岡部尚、菅野莉央、天光眞弓、小田豊　ほか<br>2009年 / 58分 / HD / カラー',
                    synopsis: '東京藝大修了後に自主制作で撮られた中篇。結婚式を目前にしたヒロインが、お腹の子どもの父親は元彼である可能性に思い悩むうちに式当日を迎える――という設定を濱口が提示して藝大の先輩・渡辺裕子が脚本を執筆。『PASSION』の後日談的世界観とも言え、心地よい語り口で見せる抱腹絶倒のシチュエーション・コメディになっている。電車が登場することの多い濱口作品の中でも際立って多彩な電車が登場する点も注目したい。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_06_img.jpg'
                },
                {
                    id: '7',
                    title: 'なみのおと',
                    information: '製作：東京藝術大学大学院映像研究科 / プロデューサー：藤幡正樹、堀越謙三 / 監督：濱口竜介、酒井耕 / 撮影：北川喜雄 / 整音：黄永昌<br>2011年 / 142分 / HD（Blu-ray上映） / カラー',
                    synopsis: 'せんだいメディアテークの東日本大震災記録映像事業の一環で制作されたドキュメンタリー。濱口と共に酒井耕が共同監督にあたっている。津波の被害を受けた沿岸部の人々の体験が、２人組、３人組でそれぞれが向き合って語られる。カメラは正面からのバストサイズで被写体を映し出し、画面を見つめる観客も必然的に語り手を見つめて耳を傾けることになる。語られる内容によって差異をつけることなく、個々の顔と声に焦点を当てる。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_07_img.jpg'
                },
                {
                    id: '6',
                    title: 'なみのこえ　新地町',
                    information: '製作：サイレントヴォイス / プロデューサー：芹沢高志、相澤久美 / 監督：濱口竜介、酒井耕 / 実景撮影：北川喜雄 / 整音：鈴木昭彦<br>2013年 / 103分 / HD（Blu-ray上映） / カラー',
                    synopsis: '気仙沼篇と同時公開された『なみのおと』に続く三部作の第二部。福島県新地町が舞台となり、異なる関係性で結ばれた人々の対話が展開する。３０代の女性同士の対話には『ハッピーアワー』の原型とも言える瞬間が垣間見える。濱口が聞き手として参加した時にもカメラは相手の語りを聞く濱口の表情を映し続けており、自作に出演することも少なくない濱口の存在と撮影方法がフィクションとドキュメンタリーの境界を曖昧化させていく。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_08_img.jpg'
                },
                {
                    id: '5',
                    title: 'なみのこえ　気仙沼',
                    information: '製作：サイレントヴォイス / プロデューサー：芹沢高志、相澤久美 / 監督：濱口竜介、酒井耕 / 実景撮影：佐々木靖之 / 整音：黄永昌<br>2013年 / 109分 / HD（Blu-ray上映）/ カラー',
                    synopsis: '『なみのおと』の続編に当たる宮城県気仙沼で撮影されたドキュメンタリー。『親密さ』のインタビュー場面を思わせる対話によって構成された前作の方法論が更に押し進められ、近い関係性にある人々が対話して生まれる親密な空間で語られる過去と未来。口数の少ない妻を前に言葉を引き出そうとする夫との対話は劇映画でもドキュメンタリーでも捉えることの出来なかった夫婦の間に観客が不意に紛れ込んだかの様な濃密な時間が流れる。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_09_img.jpg'
                },
                {
                    id: '4',
                    title: 'うたうひと',
                    information: '製作：サイレントヴォイス / プロデューサー：芹沢高志、相澤久美 / 監督：濱口竜介、酒井耕 / 撮影：飯岡幸子、北川喜雄、佐々木靖之 / 整音：黄永昌<br>2013年 / 120分 / HD / カラー',
                    synopsis: '東北三部作最終作は、東北に伝承される民話の語りを記録。老人たちから民話を聞き出してきた小野和子をクローズアップし、語り手と同時に彼女が聞く姿を印象深く映し出す。十数人が１人の語り手の声をじっと聞く姿は、聞く力によって語る力を大きくさせることを目の当たりにさせる。三部作を終えた濱口は再びフィクションに向かい、「聞く」に重点を置いた即興演技ワークショップを開始し、やがて『ハッピーアワー』へと結実する。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_10_img.jpg'
                },
                {
                    id: '3',
                    title: '天国はまだ遠い',
                    information: 'プロデューサー：高田聡、岡本英之 / 監督・脚本：濱口竜介 / 撮影：北川喜雄 / 録音：西垣太郎 / 整音：松野泉 / 音楽：和田春 / 助監督：高野徹<br>出演:岡部尚、小川あん、玄理<br>2016年 / 38分 / HD / カラー',
                    synopsis: '女子高生の三月と暮らしている雄三は、三月の姉から15年前に殺された妹に関するドキュメンタリーの被写体になって欲しいと頼まれる。霊感の強い男が地縛霊と同棲している幽霊譚だが、インタビューの中で雄三が憑依されて三月に化身する過程を１カットで見せるのが濱口作品らしい。観客はそれを演じる岡部尚を眺めながら虚構と現実の間を体感することになる。『ハッピーアワー』クラウドファンディング特典として制作された短篇。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_11_img.jpg'
                },
                {
                    id: '2',
                    title: '記憶の香り',
                    information: '製作：東京藝術大学大学院映像研究科 / プロデューサー：東條真努香 / 監督：濱口竜介 / 脚本：小林美香 / 撮影・照明：佐々木靖之 / 録音：草刈悠子 / 美術：田中浩二 / 編集：筒井武文 / 音楽：和田春 / 助監督：船曳真珠<br>出演：藤川俊生、河井青葉、根岸結衣　ほか<br>2006年 / 27分 / 16mm→HD （Blu-ray上映） / カラー',
                    synopsis: '東京藝大の課題として制作された短篇。今のところ唯一の１６ミリ作品であり、濱口映画のミューズ河井青葉が初めて登場する。通勤途中にいつもバス停で見かける少女を気に留めた主人公は、彼女が交通事故で死んだ母を待っている噂を耳にして話しかける。初めて他人の脚本で撮ることに挑んだ濱口は「わからないまま、書かれたとおりに撮っていった」と語っており、初期作の試行錯誤が伺える。撮影は『寝ても覚めても』の佐々木靖之。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_12_img.jpg'
                },
                {
                    id: '1',
                    title: '遊撃',
                    information: '製作：東京藝術大学大学院映像研究科 / プロデューサー：塩原史子 / 監督・脚本：濱口竜介 / 撮影：湯澤祐一 / 録音：光地拓郎 / 編集：山本良子 / 美術：松崎雅 / 助監督：瀬田なつき / 制作：佐々木靖之<br>出演：土屋裕樹、工藤渉、山岡麻依子、千葉茜、北浦正之<br>2006年 / 17分 / HD（Blu-ray上映） / カラー',
                    synopsis: '先輩の誠に恋情を抱く恵一は告白するが振られてしまう。大学卒業後、助監督を経て二度の受験で東京藝大に入学した濱口へ最初に与えられた課題は「差別」をテーマにした短篇だった。同性愛を描いた点よりも告白後の夜を徹した飲み会での対話と、夜明けの海辺での再度の告白へと至る言葉の反復が味わい深い。この習作で試みた夜から朝にかけての濃密な時間と対話は、『PASSION』へと発展し、以降の作品にも受け継がれていく。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_13_img.jpg'
                },
                {
                    id: '0',
                    title: '何食わぬ顔<small>（long version）</small>',
                    information: '製作・監督・脚本・編集：濱口竜介 / 撮影：渡辺淳、濱口竜介、東辻賢治郎  / 録音：井上和士 / 音楽：David Nude、ROMAN<br>出演：松井智、濱口竜介、岡本英之、遠藤郁子、石井理絵　ほか<br>2003年 / 98分 / 8mm→SD（DVD上映） / カラー',
                    synopsis: '東大映画研究会在籍時に８ミリで制作された最初期作。死んだ兄が遺した映画を弟と友人たちが完成させようとする。劇中劇のみのショート版と違い、ロング版は追加撮影から上映会までの前半と、劇中で完成した映画の二部構成になっている。電車、夜道、テーブルを挟んでの対話など濱口映画の特徴がすでに登場し、劇中劇を越えた構造に『親密さ』の原型を見つけることが出来る。闇の中に浮き立つ白シャツでボールを蹴る場面が美しい。',
                    poster: '/netemosametemo/hamaguchi/static/img/films/film_14_img.jpg'
                }
            ]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Films.vue